import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { Navigate, Outlet } from "react-router-dom";
import UnauthorizedScreen from "./UnauthorizedScreen";

type Props = {
  redirectPath?: string;
  children?: JSX.Element | JSX.Element[];
  expectedPermission?: string; // Permissions UUID
  expectedPermissions?: string[]; // Any of these permissions grants access
};

function ProtectedRoute({ redirectPath, children, expectedPermission, expectedPermissions }: Props) {
  const hasAccess = expectedPermissions
    ? expectedPermissions.some((p) => AuthService.hasPermissionFor(p))
    : expectedPermission
      ? AuthService.hasPermissionFor(expectedPermission)
      : true;

  if (!AuthService.isLogged() || !hasAccess) {
    if (redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }

    return <UnauthorizedScreen />;
  }
  return children ? children : <Outlet />;
}

export default ProtectedRoute;
